import React, { useEffect, useState } from 'react';
import { Form, Select, Table, Button, Input, Spin } from 'antd';
import axios from "axios";
import Message from '@beisen-phoenix/message';

import './shl_evaluation.scss';

const columns = [
  {
    title: '姓名',
    dataIndex: 'name',
    render: (text, record, index) => {
      return (
        <>
          <span>{text}</span>
          <Form.Item
            hidden
            name={["applicants", index, "applicantId"]}
            initialValue={record.applicantId}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            name={["applicants", index, "applyId"]}
            initialValue={record.applyId}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            name={["applicants", index, "optUserId"]}
            initialValue={record.optUserId}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            name={["applicants", index, "name"]}
            initialValue={record.name}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            name={["applicants", index, "gender"]}
            initialValue={record.gender}
          >
            <Input />
          </Form.Item>
        </>
      )          
    }
  },
  {
    title: <span className='required-label'>邮箱</span>,
    dataIndex: 'email',
    render: (text, record, index) => {
      return (
        text ?
          <>
            <span>{text}</span>
            <Form.Item
              hidden
              name={["applicants", index, "email"]}
              initialValue={record.email}
            >
              <Input />
            </Form.Item>
          </> 
        :           
          <Form.Item
            name={["applicants", index, "email"]}
            rules={[ { required: true, type: 'email', message: '请输入正确的邮箱' } ]}
          >
            <Input />
          </Form.Item>
      )
    }
  },
  {
    title: <span className='required-label'>手机号</span>,
    dataIndex: 'mobile',
    render: (text, record, index) => {
      return (
        text ?
          <>
            <span>{text}</span>
            <Form.Item
              hidden
              name={["applicants", index, "mobile"]}
              initialValue={record.mobile}
            >
              <Input />
            </Form.Item>
          </> 
        :          
          <Form.Item
            name={["applicants", index, "mobile"]}
            rules={[ { required: true, pattern: '^[1][0-9][0-9]{9}$', message: '请输入11位手机号码' } ]}
          >
            <Input />
          </Form.Item>
      )        
    }
  },
];

const SHL_Evaluation = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const tenantId = urlParams.get("tenantId");
  const commonParamater = urlParams.get("commonParamater");
  const [paperList, setPaperList] = useState([]);
  const [applicantList, setApplicantList] = useState([]);
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  // 或者测评状态 - 是否可以提交
  const checkStatus = () => {
    axios
      .get(`/api/lehe/check-shl-eval-status?tenantId=${tenantId}&commonParamater=${commonParamater}`, {})
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.code === "200") {
            setStatus(true);
          }else {
            Message.error({ message: res?.data?.message });
          }
        }
      });
  }
  // 获取测评试卷
  const getShlPaper = () => {
    axios
      .get(`/api/lehe/get-shl-eval-paper?tenantId=${tenantId}&commonParamater=${commonParamater}`, {})
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.code === "200") {
            setPaperList(res.data.data || []);
          }
        }
      });
  }
  // 获取人员信息
  const getApplicantList = () => {
    axios
      .get(`/api/lehe/get-shl-applicant-list?tenantId=${tenantId}&commonParamater=${commonParamater}`, {})
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.code === "200") {
            setApplicantList(res.data.data || []);
          }
        }
      });
  }
  // 发起测评
  const startShlEval = (formData) => {
    setLoading(true);

    const params = {
      tenantId,
      commonParamater,
      ...formData,
    };
    const bodyString = JSON.stringify(params);

    axios.post("/api/lehe/start-shl-eval", bodyString, { headers: { "Content-Type": "application/json" } })
      .then(res => {
        if (res.status === 200) {
          if (res?.data?.code === "200") {
            setStatus(false);
            Message.success({ message: res?.data?.message || '提交成功！' });
          }else {
            Message.error({ message: res?.data?.message });
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getShlPaper();
    getApplicantList();
    checkStatus();
  }, [])

  return (
    <Spin spinning={loading}>
      <div className="shl_evaluation_wrapper">
        <div className="form_wrapper">
          <Form
            layout="vertical"
            onFinish={(values) => {
              startShlEval(values)
            }}
          >
            <Form.Item label="测评试卷" name="evalPaperIds" rules={[ { required: true, message: '必选项' } ]}>
              <Select
                placeholder="请选择"
                mode="multiple"
                allowClear
                options={(paperList || []).map(item => ({ value: item.evalPaperId, label: item.evalPaperName }))}
              />
            </Form.Item>
            <Form.Item label="人员信息" name="applicants" rules={[ {required: true} ]}>
              <Table
                rowKey={(record) => (`${record.applicantId}_${record.applyId}`)}
                dataSource={applicantList}
                columns={columns}
                pagination={false}
              />
            </Form.Item>
            <Form.Item style={{ textAlign: 'center', marginTop: '20px' }}>
              <Button type="primary" size="large" htmlType="submit" disabled={!status}>提交</Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Spin>
  )
}

export default SHL_Evaluation;